// Mirrors Websites::ThemeCompiler so a theme edit lands on the canvas without
// a round trip. The server stays authoritative: it recompiles on save and the
// next page load is served from its output.

const FONT_STACKS = {
  inter: '"Inter", system-ui, sans-serif',
  figtree: '"Figtree", system-ui, sans-serif',
  "source-serif": '"Source Serif 4", Georgia, serif',
  playfair: '"Playfair Display", Georgia, serif',
  lora: '"Lora", Georgia, serif',
  "jetbrains-mono": '"JetBrains Mono", ui-monospace, monospace'
}

const TEXT_STEPS = { small: -1, body: 0, lead: 1, h3: 2, h2: 3, h1: 4 }
const SPACE_STEPS = { none: 0, xs: 0.5, s: 1, m: 2, l: 4, xl: 8, "2xl": 12 }
const RADIUS_STEPS = { none: 0, s: 0.5, m: 1, l: 2 }

export const fontStack = (key) => FONT_STACKS[key] || FONT_STACKS.inter

// `read(group, key)` resolves a value against the theme and its defaults.
export const paintTheme = (document, roles, read) => {
  if (!document) return

  const root = document.documentElement
  const set = (name, value) => root.style.setProperty(name, value)

  roles.forEach((role) => set(`--color-${role.replace("_", "-")}`, read("palette", role)))

  const base = Number(read("typography", "base"))
  const ratio = Number(read("typography", "scale"))
  Object.entries(TEXT_STEPS).forEach(([name, step]) =>
    set(`--text-${name}`, `${Math.round(base * ratio ** step)}px`))

  const unit = Number(read("spacing", "unit"))
  Object.entries(SPACE_STEPS).forEach(([name, multiplier]) =>
    set(`--space-${name}`, `${Math.round(unit * multiplier)}px`))

  const radius = Number(read("shape", "radius"))
  Object.entries(RADIUS_STEPS).forEach(([name, multiplier]) =>
    set(`--radius-${name}`, `${Math.round(radius * multiplier)}px`))

  set("--font-heading", fontStack(read("typography", "heading")))
  set("--font-body", fontStack(read("typography", "body")))
}
